/**
 * zeluslugi.ru
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

export function pluralize(n, forms) {
    return n % 10 === 1 && n % 100 !== 11
        ? forms[0]
        : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
                ? forms[1]
                : forms[2]
        );
}
